import { render } from "./InputError.vue?vue&type=template&id=05475c0c"
import script from "./InputError.vue?vue&type=script&lang=js"
export * from "./InputError.vue?vue&type=script&lang=js"
script.render = render

export default script